export const Routes = {
  HOMEPAGE: '/',
  EDIT_PROFILE: '/api/user/editProfile',
  FAVORITES: '/favourites',
  LOGIN: '/api/auth/signin',
  LOGOUT: '/api/auth/signout',
  LOGOUT_CIDAAS: '/api/auth/federated-logout',
  NEWSLETTER_API: '/api/newsletter',
  VOUCHER_API: '/api/voucher',
  SEARCH_API: '/api/vms/search',
  SHOPPING_HISTORY: '/shopping-history',
  PARENTAL_CONTROL_SETTINGS: '/user/parental-control',
  PARENTAL_CONTROL_SETTINGS_RESET: '/user/parental-control/reset',
  PARENTAL_CONTROL_VALIDATE_PIN_API: '/api/user/parental-control/validate',
  VOUCHER: '/voucher',
};
